import {
  AlignLeft,
  AtSign,
  CalendarDays,
  Hash,
  ListChecks,
  PenLine,
  Phone,
  SquareCheck,
  Type,
  type LucideIcon,
} from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FIELD_TYPES, type DocField, type FieldColumns, type FieldType } from '../types'
import { ColumnsPicker } from './ColumnsPicker'

const ICONS: Record<FieldType, LucideIcon> = {
  kisa_metin: Type,
  uzun_metin: AlignLeft,
  tarih: CalendarDays,
  telefon: Phone,
  eposta: AtSign,
  sayi: Hash,
  secim: ListChecks,
  checkbox: SquareCheck,
  imza: PenLine,
}

type Props = {
  onAddField: (partial: Pick<DocField, 'label' | 'type' | 'source' | 'variable' | 'key'>, columns: FieldColumns) => void
}

export function AddFieldGrid({ onAddField }: Props) {
  const { t } = useTranslation()
  const [columns, setColumns] = useState<FieldColumns>(1)

  return (
    <div className="space-y-3">
      <div className="space-y-1.5">
        <span className="block text-xs font-medium">{t('hr.belgeler.right.layout')}</span>
        <ColumnsPicker value={columns} onChange={setColumns} />
        {columns > 1 ? <p className="text-[11px] leading-snug text-muted-foreground">{t('hr.belgeler.right.layoutHint')}</p> : null}
      </div>
      <div className="grid grid-cols-2 gap-1.5">
        {FIELD_TYPES.map((type) => {
          const Icon = ICONS[type]
          return (
            <button
              key={type}
              type="button"
              onClick={() =>
                onAddField(
                  {
                    label: t(`hr.belgeler.fieldTypes.${type}`),
                    type,
                    source: 'personel',
                    key: `${type}_${Date.now().toString(36).slice(-5)}`,
                  },
                  columns,
                )
              }
              className="flex min-w-0 items-center gap-2 rounded-lg border bg-card px-2 py-2 text-left text-xs font-medium text-foreground/80 transition-colors hover:border-primary/40 hover:bg-primary/[0.04] hover:text-primary"
            >
              <span className="flex size-6 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
                <Icon className="size-3.5" />
              </span>
              <span className="line-clamp-2 min-w-0 leading-tight">{t(`hr.belgeler.fieldTypes.${type}`)}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
